import { apiAxiosCMS } from 'services/api';
import { PriceTagProps } from 'types/PriceTagProps';

export async function createTag(tag: PriceTagProps, handleNotify: any) {
	let isSuccess = false;

	await apiAxiosCMS
		.delete(`/promotional-tags/${tag.id}`)
		.then(() => {
			isSuccess = true;
			handleNotify('Etiqueta deletada com sucesso', 'success');
		})
		.catch(() => {
			isSuccess = false;
			handleNotify('Ocorreu algum erro ao deletar a etiqueta', 'error');
		});

	return isSuccess;
}
